/**
 * Lazy Terra Draw instance for session-only vector create / modify / scale / trace.
 */
import {
  TerraDraw,
  TerraDrawLineStringMode,
  TerraDrawPointMode,
  TerraDrawPolygonMode,
  TerraDrawSelectMode,
} from 'terra-draw';
import { TerraDrawMapLibreGLAdapter } from 'terra-draw-maplibre-gl-adapter';
import { terraSelectFlags } from '@/components/vector/vectorEditMode';

export function createLayerTerraDraw(
  map: unknown,
  options: { readonly snap: boolean; readonly scale: boolean },
): TerraDraw {
  const snapping = options.snap ? { toCoordinate: true } : undefined;
  type SelectModeOptions = ConstructorParameters<typeof TerraDrawSelectMode>[0];
  return new TerraDraw({
    adapter: new TerraDrawMapLibreGLAdapter({ map }),
    modes: [
      new TerraDrawPointMode(),
      new TerraDrawLineStringMode({ snapping }),
      new TerraDrawPolygonMode({ snapping }),
      new TerraDrawSelectMode({
        flags: terraSelectFlags(options.scale) as NonNullable<SelectModeOptions>['flags'],
      }),
    ],
  });
}
